/**
 * Global Color Palette
 * Centralized color constants for use in React components and inline styles
 */

export const COLORS = {
  // Primary brand color - Blue
  primary: '#122AD4',
  
  // Accent color - Call-to-action buttons, icons, emphasis areas - Lime
  accent: '#BCF713',
  
  // Accent hover state - Darker lime for interactive elements
  accentHover: '#A9E10E',
  
  // Background - Sections, cards, soft UI areas - Mint
  bgSecondary: '#DEE8E0',
  
  // Main background - White
  bgPrimary: '#FFFDFE',
  
  // Text and outlines - Black
  textPrimary: '#000000',
  
  // Secondary text - Dark gray (for lighter text scenarios)
  textSecondary: '#2d2d2d',
  
  // Tertiary text - Medium gray
  textTertiary: '#666666',
  
  // White - For contrast on colored backgrounds
  white: '#FFFFFF',
  
  // Border/Light gray colors for subtle UI elements
  borderLight: '#f0f0f0',
  borderLighter: '#f5f5f5',
  borderLightish: '#efefef',
  borderLightBlue: '#e8f0ff',
  borderMedium: '#e0e0e0',
  borderDisabled: '#D3D3D3',
};

/**
 * Usage in React components:
 * 
 * Example 1: Import and use in inline styles
 * import { COLORS } from '../utils/colors';
 * <span style={{ color: COLORS.primary }}>Text</span>
 * 
 * Example 2: Import specific colors
 * import { COLORS } from '../utils/colors';
 * const { primary, accent } = COLORS;
 * <button style={{ backgroundColor: accent }}>Button</button>
 */
